import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import GlobalErrorBoundary from "./components/GlobalErrorBoundary";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <GlobalErrorBoundary>
            <AppRoutes />
          </GlobalErrorBoundary>
        </BrowserRouter>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
